var map = {
	"./en/logo-bigg-map.svg": 23650,
	"./es/logo-bigg-map.svg": 14185,
	"./fr/logo-bigg-map.svg": 88170,
	"./pt/logo-bigg-map.svg": 5173
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37806;